import type { IOrderHistoryItem } from './OrderHistoryItem';
import OrderHistoryItem from './OrderHistoryItem';

import type { IAddress } from './Address';
import FulfillmentStatus from './FulfillmentStatus';

type MealSummary = {
  name: string;
  price: number;
  count: number;
};

type Shipment = {
  tracking_number: string;
  delivery_tracking_url: string;
  delivered_at?: Date;
};

enum DeliveryStatus {
  NONE = 'none',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  FAILED_TO_DELIVER = 'failed_to_deliver',
}

interface IOrderHistoryMenu {
  id: number;
  menu_id: number;
  fulfillment_status: FulfillmentStatus;
  delivery_on: Date;
  menu_type: 'WeeklyMenu';
  base_price: string;
  donated: boolean;
  donation_charity: string;
  recipient_email: string;
  plan_name: string;
  discount_value: string;
  discount_code: string;
  credits: string;
  refunded_amount: string;
  shipping_fee: string;
  sales_tax: number | string;
  total_price: string;
  shipping_address: IAddress;
  shipments: Shipment[];
  upcoming_menu_items: IOrderHistoryItem[];
  meals_summaries: MealSummary[];
  delivery_status: DeliveryStatus;

  areDetailsExpanded?: boolean;
  readonly deliveredAt?: Date;
}

class OrderHistoryMenu implements IOrderHistoryMenu {
  id: number;
  menu_id: number;
  fulfillment_status: FulfillmentStatus;
  delivery_on: Date;
  menu_type: 'WeeklyMenu';
  base_price: string;
  donated: boolean;
  donation_charity: string;
  recipient_email: string;
  plan_name: string;
  discount_value: string;
  discount_code: string;
  credits: string;
  refunded_amount: string;
  shipping_fee: string;
  shipping_surcharge: string;
  sales_tax: number | string;
  crd_fee: number | string;
  total_price: string;
  shipping_address: IAddress;
  shipments: Shipment[];
  upcoming_menu_items: OrderHistoryItem[];
  meals_summaries: MealSummary[];
  delivery_status: DeliveryStatus;

  areDetailsExpanded = false;

  constructor(attributes?: IOrderHistoryMenu) {
    Object.assign(this, attributes);

    this.upcoming_menu_items = this.upcoming_menu_items.map(
      (item) => new OrderHistoryItem(item),
    ) ?? [];
  }

  get deliveredAt(): Date | undefined {
    if (!this.shipments?.length) return undefined;

    const shipment = this.shipments.find((s) => s.delivered_at);

    // @ts-expect-error TODO: fix null safety
    return shipment ? new Date(shipment.delivered_at) : null;
  }

  get deliveryStatus(): string {
    switch (this.delivery_status) {
      case DeliveryStatus.SHIPPED:
        return 'Shipped';

      case DeliveryStatus.DELIVERED:
        return 'Delivered';

      case DeliveryStatus.FAILED_TO_DELIVER:
        return 'Failed to deliver';

      default:
        return 'Not delivered';
    }
  }
}

export { DeliveryStatus };
export type { IOrderHistoryMenu, MealSummary, Shipment };
export default OrderHistoryMenu;
